import React, { PureComponent } from 'react';
import { Tab, Icon } from 'semantic-ui-react';
import { generateCanvasUrl } from './../PackageLauncher';
import { createCanvasForCollection } from '../../AdBuilder/AdCreator';
import { returnAdCreative } from './AdBuilderAdPreviewCreative';
import { getAdGeneratePreview } from '../../../fbApi/AdPreview';
import {
  checkIfThumbnailIsValid,
  recoverThumbnailFromFb
} from '../../../utils/thumbnailRecovery';

class AdBuilderBase extends PureComponent {
  state = {
    loading: false,
    desktopPreview: '',
    mobilePreview: '',
    instagramStoryPreview: '',
    currentPreviewFormat: 'MOBILE_FEED_STANDARD',
    adFormats: [
      'MOBILE_FEED_STANDARD',
      'DESKTOP_FEED_STANDARD',
      'INSTAGRAM_STORY'
    ],
    activePreviewIndex: 0
  };

  componentDidMount() {
    this.getAdPreviewAndSetPreviewStates();
  }

  getAdPreviewAndSetPreviewStates = () => {
    this.setState({ ...this.state, loading: true }, async () => {
      const adPreviews = await this.returnAdPreviewsForAllFormats();
      this.setAdPreviewState(adPreviews);
    });
  };

  returnAdPreviewsForAllFormats = async () => {
    // returns an array of strings containing iframee html with the following order:
    // 1: mobile, 2:desktop, 2: instagram
    const { adFormats } = this.state;
    const { adType, adPrototypeEdit, getFbToken } = this.props;
    const token = getFbToken();
    const newAdPrototype = { ...adPrototypeEdit };

    const { asset_id: assetId, cards, thumbnail } = newAdPrototype;
    let recoveredThumbnail = thumbnail;

    const thumbnailIsValid =
      adType !== 'DAA' ? await checkIfThumbnailIsValid(newAdPrototype) : true;

    if (adType === 'Carousel' && cards && cards.length > 0) {
      const validThumbCards = await Promise.all(
        cards.map(async (card) => {
          const { asset_id: cardAssetId, thumbnail: cardThumbnail } = card;
          let recoveredCardThumbnail = cardThumbnail;
          const currentCard = card;
          const cardThumbnailValid = await checkIfThumbnailIsValid(card);
          if (!cardThumbnailValid) {
            recoveredCardThumbnail = await recoverThumbnailFromFb(
              cardAssetId,
              token
            );
          }
          currentCard.thumbnail = recoveredCardThumbnail;
          return Promise.resolve(currentCard);
        })
      );
      newAdPrototype.cards = validThumbCards;
    }

    if (!thumbnailIsValid) {
      recoveredThumbnail = await recoverThumbnailFromFb(assetId, token);
    }
    newAdPrototype.thumbnail = encodeURIComponent(recoveredThumbnail);

    const adPreviewsPromises = adFormats.map(async (format) => {
      const adPreview = await this.returnAdPreviewFromAdPrototype(
        format,
        adType,
        newAdPrototype,
        token
      );

      return Promise.resolve(adPreview);
    });
    const adPreviews = await Promise.all(adPreviewsPromises);
    return Promise.resolve(adPreviews);
  };

  setAdPreviewState = (adPreviewsByFormat) => {
    let desktopPreview =
      '<p>Something went wrong while generating the preview. Check the ad prototype and its assets and then try again</p>';
    let mobilePreview =
      '<p>Something went wrong while generating the preview. Check the ad prototype and its assets and then try again</p>';
    let instagramStoryPreview =
      '<p>Something went wrong while generating the preview. Check the ad prototype and its assets and then try again</p>';
    if (adPreviewsByFormat.length > 0) {
      desktopPreview = adPreviewsByFormat[0];
      mobilePreview = adPreviewsByFormat[1];
      instagramStoryPreview = adPreviewsByFormat[2];
    }
    this.setState((prevState) => ({
      ...prevState,
      desktopPreview,
      mobilePreview,
      instagramStoryPreview,
      loading: false
    }));
  };

  returnAdPreviewFromAdPrototype = async (
    adFormat,
    adType,
    adPrototypeEdit,
    token
  ) => {
    const {
      client,
      resource_id: resourceId,
      asset_id: assetId,
      footer_text: footerText,
      message,
      title
    } = adPrototypeEdit;
    const accountId =
      client && client.trim() !== '' ? client : '1659209077448923'; // Nikolai Test account ID,
    const formParameters = {
      pageId: '114266546691696', // use alexia test 1
      // Alexia test 1 access token
      pageAccessToken:
        'EAAVCUmRbyb0BAJoPwxawXNryGzZB2E3XeZCH4kFQOLdUgsWMpuUH0jns3m43LdxrFk0QfZCkByZAYC71nMhX7fuya5fqe3yWUuYM2EEISgFRaKWKgNZBllLo3QQf1KdM95RxZBFOjse2HAvdnHiCu1WkflR7ciOLA5RtdENNnbhOXrc9w3zsxZBWLx3Eb5fHagiZCt1LzRZCUpwZDZD'
    };

    // destination url for dummy previews
    const destinationUrl = 'https://constellationagency.com/';

    let canvasUrl;

    try {
      if (adType === 'Canvas') {
        canvasUrl = await generateCanvasUrl(
          resourceId,
          destinationUrl,
          formParameters
        );
      }
      if (adType === 'Collection') {
        // collection ads don't have resourceIds, so canvases have to be made manually
        // on the spot
        const collectionParams = {
          pageId: formParameters.pageId,
          pageToken: formParameters.pageAccessToken,
          token,
          url: destinationUrl,
          videoId: assetId,
          buttonName: 'Button',
          productSetName: 'ProductSet',
          destinationUrl,
          productSet: '198689737505039',
          buttonText: footerText,
          footerName: 'Footer Name',
          headline:
            title ||
            '{{vehicle.year Aa}} {{vehicle.make Aa}} {{vehicle.model Aa}}',
          description: message || 'At {{vehicle.dealer_name Aa}}'
        };
        const collectionCavnas = await createCanvasForCollection(
          collectionParams
        );
        const { canvasLink } = collectionCavnas || {};
        canvasUrl = canvasLink || '';
      }
    } catch (error) {
      canvasUrl = '';
    }

    const adPrototype = { ...adPrototypeEdit };
    adPrototype.canvasUrl = canvasUrl || '';

    const adCreative = returnAdCreative(adType, adPrototype, formParameters);

    let adPreview = '';

    if (
      (adType === 'Canvas' || adType === 'Collection') &&
      adFormat === 'DESKTOP_FEED_STANDARD'
    ) {
      adPreview = `<p>${adType} Ads do not support desktop previews</p>`;
    } else {
      const { data, error } = await getAdGeneratePreview(
        accountId,
        adCreative,
        adFormat || 'DESKTOP_FEED_STANDARD',
        token
      );
      let adPreviewUrl = '';
      const previewHeight =
        !adFormat || adFormat === 'DESKTOP_FEED_STANDARD' ? 690 : 620;
      if (error) {
        adPreview =
          '<p>Something went wrong while generating the preview. Check the ad prototype and its assets and then try again</p>';
      } else {
        adPreviewUrl = data[0].body;
        adPreviewUrl = adPreviewUrl.substring(adPreviewUrl.indexOf('src') + 5);
        adPreviewUrl = adPreviewUrl.substring(0, adPreviewUrl.indexOf('"'));
        adPreview = `<iframe src="${adPreviewUrl}" height="${previewHeight}" scrolling="yes" style="border: none;"></iframe>`;
      }
    }

    const adPreviewElement = document.getElementById(`${adFormat}`);
    if (adPreviewElement) {
      adPreviewElement.innerHTML = adPreview;
    }
    return adPreview;
  };

  returnIframeDivDimensions = (format) => {
    let iframeHeight = 690;
    let iframeMaxWidth = 720;
    let offsetVertical = 1500;
    switch (format) {
      case 'MOBILE_FEED_STANDARD':
        iframeHeight = 620;
        iframeMaxWidth = 350;
        offsetVertical = 900;
        break;
      case 'INSTAGRAM_STORY':
        iframeHeight = '567px';
        break;
      default:
        iframeHeight = 690;
        iframeMaxWidth = 720;
        offsetVertical = 1500;
        break;
    }
    return { iframeHeight, iframeMaxWidth, offsetVertical };
  };

  showAdPreview = (previewFormat) => {
    const { desktopPreview, mobilePreview, instagramStoryPreview } = this.state;
    switch (previewFormat) {
      case 'MOBILE_FEED_STANDARD':
        document.getElementById(`${previewFormat}`).innerHTML = mobilePreview;
        break;
      case 'INSTAGRAM_STORY':
        document.getElementById(
          `${previewFormat}`
        ).innerHTML = instagramStoryPreview;
        break;
      default:
        document.getElementById(`${previewFormat}`).innerHTML = desktopPreview;
        break;
    }
  };

  renderPreviewTabs = () => {
    const previewTabs = this.getPreviewTabs();
    const { activePreviewIndex } = this.state;
    return (
      <Tab
        renderActiveOnly={false}
        panes={previewTabs}
        activeIndex={activePreviewIndex}
        onTabChange={this.handleTabChange}
      />
    );
  };

  handleTabChange = (e, data) => {
    const { activeIndex } = data;
    this.setState((prevState) => ({
      ...prevState,
      activePreviewIndex: activeIndex
    }));
  };

  getPreviewTabs = () => {
    const {
      adFormats,
      desktopPreview,
      mobilePreview,
      instagramStoryPreview
    } = this.state;
    const mobileFormat = adFormats[0];
    const desktopFormat = adFormats[1];
    const instagramStoryFormat = adFormats[2];
    const desktopAd = {
      key: 'Desktop',
      menuItem: { key: 'Desktop', icon: <Icon size="big" name="desktop" /> },
      pane: (
        <Tab.Pane>
          {this.renderPreview(desktopFormat, 'Desktop', desktopPreview)}
        </Tab.Pane>
      )
    };

    const mobileAd = {
      key: 'Mobile',
      menuItem: { key: 'Mobile', icon: <Icon size="big" name="mobile" /> },
      pane: (
        <Tab.Pane>
          {this.renderPreview(mobileFormat, 'Mobile', mobilePreview)}
        </Tab.Pane>
      )
    };

    const instagramStory = {
      key: 'Instagram Story',
      menuItem: {
        key: 'Instagram Story',
        icon: <Icon size="big" name="instagram" />
      },
      pane: (
        <Tab.Pane>
          {this.renderPreview(
            instagramStoryFormat,
            'Instagram Story',
            instagramStoryPreview
          )}
        </Tab.Pane>
      )
    };

    return [mobileAd, desktopAd, instagramStory];
  };

  renderPreview = (format, title) => {
    const { loading } = this.state;
    const iframeDimensions = this.returnIframeDivDimensions(format);
    const { iframeHeight, iframeMaxWidth, offsetVertical } = iframeDimensions;
    return (
      <div>
        <h4>{title}</h4>
        {loading ? <span>{' Loading Preview...'} </span> : null}
        <div
          id={format}
          style={{ height: iframeHeight, maxWidth: iframeMaxWidth }}
          offsetVertical={offsetVertical}
        />
      </div>
    );
  };

  render() {
    const previewTabs = this.getPreviewTabs();
    const { activePreviewIndex } = this.state;
    return (
      <Tab
        renderActiveOnly={false}
        panes={previewTabs}
        activeIndex={activePreviewIndex}
        onTabChange={this.handleTabChange}
      />
    );
  }
}

export default AdBuilderBase;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdBuilderAdPreview.js